import React from 'react';
import {
    TRANSLATIONS_MEALS_LIMIT_REPLACEMENT,
    TRANSLATIONS_PICKED_PRODUCTS_COUNT_REPLACEMENT,
} from '../shared/constants';

export const PhaseNavigationBlock = ({
    name,
    portionCount,
    isSelected,
    translations,
    onPhaseClick,
    isDisabled,
    phaseItemCount,
    isPhaseWithError,
}) => (
    <button
        className={`
            phase-navigation__block
            ${isSelected ? ' phase-navigation__block--selected' : ''}
            ${isDisabled ? ' phase-navigation__block--disabled' : ''}
            ${isPhaseWithError ? ' phase-navigation__block--with-error' : ''}
        `}
        onClick={isDisabled ? undefined : onPhaseClick}
        data-tip={translations['eshop.configurator.phase_not_completed']}
        data-tip-disable={!isDisabled}
    >
        <div className="phase-navigation__block__title">{name}</div>
        <div
            className={`phase-navigation__block__meal-count${
                phaseItemCount === portionCount ? ' phase-navigation__block__meal-count--completed' : ''
            }`}
        >
            {translations['eshop.configurator.message_part.selected']}:{' '}
            {translations['eshop.configurator.message_part.product_of_meals']
                .replace(TRANSLATIONS_PICKED_PRODUCTS_COUNT_REPLACEMENT, phaseItemCount)
                .replace(TRANSLATIONS_MEALS_LIMIT_REPLACEMENT, portionCount)}
        </div>
    </button>
);
